/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from 'reactstrap';
import SimpleTooltip from '../../../simple-tooltip';
import ToolbarButton, { ToolbarButtonProps } from './ToolbarButton';
import ToolbarStatusSpan from './ToolbarStatusSpan';

interface ToolbarCollapsedMenuProps {
  title: string;
  buttons: ToolbarButtonProps[];
  standardShow: number
}

const ToolbarCollapsedMenu = (props: ToolbarCollapsedMenuProps) => {
  const { buttons, title, standardShow } = props;
  const [isOpen, setOpenMenu] = useState(false);
  const toggle = () => setOpenMenu(!isOpen);

  const isEmpty = buttons.length === 0;

  const collapseStandardsView = () => {
    return (
      <div className='dropdown-menu-wrapper'>
        <div className='d-flex justify-content-start'>
          {buttons && buttons.slice(0, standardShow).map((button, i) => {
            return <ToolbarButton
              key={`${title}-${i}`}
              {...button}
            />
          })}
        </div>
        {
          buttons.length >= standardShow &&
          <div className='dropdown-container'>
            <Dropdown isOpen={isOpen} toggle={() => setOpenMenu(!isOpen)}>
              <SimpleTooltip text='Click to view more standards'>
                <DropdownToggle color='transparent'>
                  <i className='fas fa-ellipsis-v'></i>
                </DropdownToggle>
              </SimpleTooltip>
              <DropdownMenu>
                {buttons.slice(standardShow).map((button, i) => (
                  <DropdownItem key={i}>
                    <ToolbarStatusSpan
                      key={`${title}-${i}`}
                      {...button}
                      onClick={() => {
                        if (button.onClick) {
                          toggle()
                          button.onClick();
                        }
                      }}
                    />
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        }
      </div>
    )
  }

  const standardsView = () => {
    return (
      <div className='d-flex justify-content-start'>
        {buttons && buttons.map((button, i) => (
          <ToolbarButton
            key={`${title}-${i}`}
            {...button}
          />
        ))}
      </div>
    )
  }

  return <div className='d-flex flex-column'>
    <div className='header'>{isEmpty ? '' : title}</div>
    {buttons.length > 4 ? collapseStandardsView() : standardsView()}
  </div>
}

export default ToolbarCollapsedMenu;
